export const isSpreadsheetResultsFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return (
    fileName.endsWith('.xlsx') ||
    fileType.includes('spreadsheetml') ||
    fileType.includes('ms-excel')
  );
};

export const resolveResultsFileSource = (file: File): string => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  if (isSpreadsheetResultsFile(file)) return 'csv';
  if (fileName.endsWith('.xml') || fileType.includes('xml')) return 'junit-xml';
  if (fileName.endsWith('.json') || fileType.includes('json')) return 'mocha-json';
  if (fileName.endsWith('.csv') || fileType.includes('csv')) return 'csv';
  return 'results';
};

export const isCsvResultsFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return fileName.endsWith('.csv') || fileType.includes('csv') || isSpreadsheetResultsFile(file);
};

export const isJsonResultsFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return fileName.endsWith('.json') || fileType.includes('json');
};

export const isXmlResultsFile = (file: File): boolean => {
  if (isSpreadsheetResultsFile(file)) return false;
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return fileName.endsWith('.xml') || fileType.includes('xml');
};

export const isSupportedResultsFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  const fileType = file.type.toLowerCase();
  return (
    fileName.endsWith('.xml') ||
    fileName.endsWith('.json') ||
    fileName.endsWith('.csv') ||
    fileName.endsWith('.xlsx') ||
    fileType.includes('xml') ||
    fileType.includes('json') ||
    fileType.includes('csv') ||
    fileType.includes('spreadsheetml') ||
    fileType.includes('ms-excel')
  );
};
